import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import "./style.scss";
import RootNavigator from "navigator";

import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <RootNavigator />
      </PersistGate>
    </Provider>
  );
};

export default App;
